import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import CheckoutLayout from "../../components/CheckoutLayout/CheckoutLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";
import EventDirectory from "@/modules/eventRegistration/features/EventDirectory/components/EventDirectory/EventDirectory";
import EventDetails from "@/modules/eventRegistration/features/EventDirectory/components/EventDetails/EventDetails";
import MyRegistrationsPage from "@/modules/eventRegistration/features/MyRegistrations/components/MyRegistrationsPage/MyRegistrationsPage";
import CompanyEventRegistrationsPage from "@/modules/eventRegistration/features/CompanyEventRegistrations/components/CompanyEventRegistrationsPage/CompanyEventRegistrationsPage";
import EventRegistrationPage from "@/modules/eventRegistration/features/EventRegistration/components/EventRegistrationPage/EventRegistrationPage";
import Confirmation from "@/modules/eventRegistration/features/EventRegistration/components/Confirmation/Confirmation";
import MyTrainingHistoryPage from "@/modules/hub/features/MyTrainingHistory/components/MyTrainingHistoryPage/MyTrainingHistoryPage";
import MyVouchersPage from "@/modules/eventRegistration/features/MyVouchers/components/MyVouchersPage/MyVouchersPage";
import MyProductsHistoryPage from "@/modules/eventRegistration/features/MyProductsHistory/components/MyProductsHistoryPage/MyProductsHistoryPage";
import MyTransactionHistoryPage from "@/modules/eventRegistration/features/MyTransactionHistory/components/MyTransactionHistoryPage/MyTransactionHistoryPage";

// Browsing pages — full app shell with sidebar/nav
const EventRegistrationMainLayout = () => (
  <MainLayout section="event-registration" />
);

// Checkout pages — stripped-down focused layout
const EventRegistrationCheckoutLayout = () => <CheckoutLayout />;

const EventRegistrationRoutes = (
  <>
    {/* Browsing — full app shell */}
    <Route
      element={<AuthenticationGuard component={EventRegistrationMainLayout} />}
      path="/event-registration"
    >
      <Route element={<EventDirectory />} path="events" />
      <Route element={<EventDetails />} path="events/:uuid" />
      <Route element={<MyRegistrationsPage />} path="my-registrations" />
      <Route
        element={
          <PermissionGuard requiredPermissions={["event-registration-company"]}>
            <CompanyEventRegistrationsPage />
          </PermissionGuard>
        }
        path="company-registrations"
      />
      <Route element={<MyTrainingHistoryPage />} path="my-training-history" />
      <Route element={<MyVouchersPage />} path="my-vouchers" />
      <Route element={<MyProductsHistoryPage />} path="my-products-history" />
      <Route
        element={<MyTransactionHistoryPage />}
        path="my-transaction-history"
      />
    </Route>

    {/* Checkout + confirmation — focused layout */}
    <Route
      element={
        <AuthenticationGuard component={EventRegistrationCheckoutLayout} />
      }
      path="/event-registration"
    >
      <Route
        element={<EventRegistrationPage />}
        path="events/:eventSessionUuid/register"
      />
      <Route
        element={<Confirmation />}
        path="events/:eventCheckoutSessionUuid/confirmation"
      />
    </Route>
  </>
);

export default EventRegistrationRoutes;
